// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.scrollbar-inner .scroll-element.scroll-y[data-v-df484230]{\n  background-color: #e5e5e594 !important;\n  width: 8px !important;\n  opacity: 1 !important;\n}\n.scrollbar-inner > .scroll-element .scroll-element_track[data-v-df484230], .scrollbar-inner > .scroll-element .scroll-bar[data-v-df484230]{\n  opacity: unset!important;\n}\n.loader.force-right-0[data-v-df484230]{\n  right:0!important;\n}\n", ""]);
// Exports
module.exports = exports;
